import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deleteApiData } from "../helpers/AxiosInstance";

interface IUseDeleteHook {
  queryKey: string[];
}

const useDeleteHook = ({ queryKey }: IUseDeleteHook) => {
  const queryClient = useQueryClient();

  const {
    isPending: isDeleting,
    mutateAsync: deleteData,
    isSuccess,
    data,
    isError,
  } = useMutation({
    mutationFn: deleteApiData,
    onSuccess: (res) => {
      const status = res?.status;
      const responseData = res?.data;
      if (status === 200 || status === 204) {
        toast.success(responseData?.message || "Deleted successfully");
      } else if (responseData?.non_field_errors?.[0]) {
        toast.error(responseData.non_field_errors[0]);
      } else {
        toast.error(responseData?.message || "Something went wrong");
      }
    },
    onError: () => {
      toast.error("An error occurred while deleting.");
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey,
        refetchType: "active",
      });
    },
  });

  return {
    isDeleting,
    deleteData,
    isSuccess,
    data,
    isError,
  };
};

export default useDeleteHook;
